import Vue from 'vue'
import "./common/init"
import App from './App.vue'
import plugin from "./plugin/index";
import axios from "./common/req";
// import {getToken, setToken} from "./common/storage";
// import auth from "./common/auth";
// import {getQuery} from "./common/tool";

Vue.use(plugin);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue({
  render: h => h(App),
}).$mount('#app')
// let token = getToken();
// let code = getQuery("code");
// if(token) {
//   new Vue({
//     render: h => h(App),
//   }).$mount('#app')
// } else if(code) {
//   axios({
//     url: '/official/auth',
//     method: 'GET',
//     params: {code}
//   }).then(res => {
//     console.log(res);
//     if (res.code == 0) {
//       setToken(res);
//       new Vue({
//         render: h => h(App),
//       }).$mount('#app')
//       // let state = getQuery("state");
//       // location.replace(location.origin + decodeURIComponent(state));
//     } else {
//       Vue.$toast(res.msg);
//     }
//   }).catch(err => {
//     console.log(err);
//   });
// } else {
//   auth();
// }

// import VConsole from "vconsole";
// new VConsole();
